import type {ColumnListItemType} from '../../../../core/entities/columns/schema';
import type {
  CompanyPageColumnPostType,
  NativeAdType,
} from '../../../../core/entities/companyDetail/schema';

export type ColumnCardProps = {
  post: CompanyPageColumnPostType | NativeAdType | ColumnListItemType;
  isSponsored: boolean;
  className?: string;
};

export {ColumnCardContainer as ColumnCard} from './container';
